import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

export type DialogTone =
  | 'default'
  | 'info'
  | 'warning'
  | 'error'
  | 'success';

@Component({
  selector: 'app-dialog',
  standalone: true,
  templateUrl: './dialog.html',
  styleUrl: './dialog.scss',
})
export class Dialog {
  @Input() open = false;
  @Input() title = '';
  @Input() closeOnBackdrop = true;

  /** Adds a matching accent icon in the header. */
  @Input() tone: DialogTone = 'default';

  @Output() closed = new EventEmitter<void>();

  close(): void {
    this.closed.emit();
  }

  onBackdropClick(): void {
    if (this.closeOnBackdrop) {
      this.close();
    }
  }

  stopPropagation(event: MouseEvent): void {
    event.stopPropagation();
  }
}
